import styled from "styled-components";
import Impressoras from "../../assets/maquinasImpressao.svg"
import Faixada from "../../assets/faixada.png"
import Tapete from "../../assets/tapeteGuaranaGrande.png"
import Caminhoes from "../../assets/caminhoes.png"
import Futbol from "../../assets/futbol.png"
import ParedeShell from "../../assets/paredeShell.png"
import BackgroundFooter from "../../assets/backgroundFooter.png"

export const PaginaStyle = styled.div`
    overflow: hidden;
    .zapzap{
        position: fixed;
        bottom: 30px;
        right: 20px;
        cursor: pointer;
        z-index: 999;
        svg{
            width: 60px;
        }
    }

    .h2-header-bottom{
        font-size: 30px;
        width: 100%;
        max-width: 1700px;
        margin: 0 auto;
        padding: 80px 0px;
        font-size: 42px;
        font-weight: 300;
        text-align: center;

        b{
            font-size: 42px;
        }
    }

    .texto-bottom{
        background-color: #ffffff;
        position: relative;
    }

    .h3-mobile{
            font-size: 22px;
            font-weight: 300;
            text-align: center;
            margin-top: 70px;

            b{
                font-size: 22px;
                font-weight: 500;
            }
        }

    .faixa-verde{
        position: relative;
        background-color: rgba(0, 112, 70, 1);
        height: max-content;
        display: flex;
        align-items: center;
        position: relative;
        height: 300px;

        .body-desktop{
            display: flex;
            width: 90%;
            margin: 0 auto;
            padding: 60px 0px;

            h3{
                display: none;
            }
        }

        h3{
            width: 50%;
            max-width: 800px;
            color: #ffffff;
            font-size: 36px;
            font-weight: 200;

            b{
                color: #ffffff;
                font-size: 36px;
                font-weight: 500;
            }
        }

        .globo-cortado{ 
            width: 100%;
            height: 300px;
            margin: 0 auto;
            display: flex;
            justify-content: center;


            div{
                height: 100%;
                height: 300px;
            }

            svg{
                width: auto;
                height: 100%;
                height: 300px;
            }
        }
    }


    .div-impressoes{
        display: flex;
        flex-direction: column;
        margin: 20px 0px 60px;
        position: relative;

        .impressoras{
            width: 100%;
            height: 500px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(${Impressoras});
            border-radius: 0px 6px 6px 0px;
        }

        .logo-transparente{
                display: none;
            }

        .div-direita{
            display: flex;
            position: relative;
            flex-direction: column;
            width: 100%;

            .column{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            
            .cards{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                margin: 60px auto 0px;

                .card{
                    width: 60%;
                    text-align: center;
                    margin-bottom: 30px;    
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    

                    span{
                        max-width: 300px;
                        font-size: 16px;
                    }

                    div{
                        width: 100%;
                        height: auto;

                        div{
                            width: 100%;

                            svg{
                                width: 100%;
                                height: auto;
                                border-radius: 0px 25px 25px 0px;

                                rect{
                                    width: 100%;
                                }

                                g{
                                    width: 100%;
                                    height: auto;
                                    border-radius: 0px 25px 25px 0px;
                                }
                            }
                        }
                    }
                }
            }
        }

        .h4-desktop{
            display: none;
            margin: -10px 0px 20px;
            font-size: 42px;
            font-weight: 300;

            b{
                font-size: 42px;
            }
        }

        h5{
            width: 90%;
            text-align: center;
            margin: 50px auto 0px;
            font-size: 26px;
            font-weight: 300;

            b{
                font-size: 26px;
            }
        }
    }

    .h4-mobile{
            width: max-content;
            margin: 30px auto 0px;
            font-size: 23px;
            font-weight: 300;

            b{
                font-size: 23px;
            }
        }

    .div-produtos-servicos{
        margin-top: 100px;
        width: 100%;

        h3{
            width: 100%;
            text-align: center;
            margin: 0 auto;
            font-size: 36px;
            font-weight: 300;
            margin-bottom: 70px;

            b{
                font-size: 36px;
                font-weight: 500;
                margin-left: 10px;
            }
        }
    }

    .div-produtos-servicos{
        .cards{
            width: 96%;
            display: flex;
            margin: 0 auto;
            justify-content: space-between;
            margin-bottom: 90px;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 3px;
            

        .card{
            position: relative;
            width: 50%;
            max-width: 260px;
            aspect-ratio: 1 / 1;
            border: 4px solid #007046;
            border-radius: 20px;
            display: flex;
            text-align: center;
            align-items: center;
            padding: 10px;
            width: 100%;
            max-width: 260px;
            margin: 0 auto 30px;

            .icone{
                position: absolute;
                background-color: #007046;
                top: -30px;
                left: 50%;
                transform: translateX(-50%);
                width: 50px;
                height: 50px;
                border-radius: 300px;
                display: flex;
                justify-content: center;
                align-items: center;

                svg{
                    margin-top: 6px;
                    width: 30px;
                    height: 30px;
                }
            }

            h5{
                font-size: 15px;
                font-weight: 300;
                margin-top: 30px;

                b{
                    font-size: 15px;
                }
            }
        }
    }

    .div-h4{
            display: flex;
            width: 90%;
            max-width: 1700px;
            text-align: center;
            margin: 0 auto 80px;
            
            h4{
                font-size: 32px;
                font-weight: 300;
            }

            b{
                font-size: 32px;
                font-weight: 600;
            }
        }
    }

    .div-marcas{
        display: flex;
        align-items: center;
        width: 100%;
        padding: 40px 0px 40px;
        background-color: #007046;

        .body{
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 90%;
            margin: 0 auto;
            flex-direction: column;
        }

        .mobile{
            display: flex;
            }

            .desktop{
                display: none;
            }

        h2{
            color: #ffffff;
            width: 500px;
            font-size: 30px;
            font-weight: 300;
            width: 100%;
            text-align: center;

            b{
                color: #ffffff;
                font-size: 30px;
                font-weight: 600;
            }
        }

        .marcas{
            margin-top: 80px;
            display: flex;
            width: 100%;
            max-width: 337px;
            flex-wrap: wrap;
            gap: 20px 40px;
            justify-content: center;

            .linha-dois{
                    margin-top: 15px;
                    gap: 20px 60px;
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    height: max-content;
                    justify-content: center;

                    div{
                        width: 125px;
                        display: flex;
                        justify-content: center;
                    }
                }
            
            .ambev{
                width: 113px;
                height: 30px;
                position: relative;
                bottom: 8px;
            }

            .arcor{
                width: 88px;
                height: 60px;
            }

            .kfc{
                width: 90px;
                height: 26px;
                position: relative;
                top: 6px;
                left: 3px;
            }

            .mars{
                width: 100px;
                height: 30px;
                position: relative;
                bottom: 6px;
            }

            .burguer-king{
                width: 50px;
                position: relative;
                top: 10px;
                right: 3px;
            }

            .oxxo{
                width: 80px;
                position: relative;
                right: 4px;
            }

            .red-bull{
                width: 110px;
                height: 32px;
                position: relative;
                left: 13px;
            }

            .pepsico{
                width: 100px;
                height: 23px;
                position: relative;
                right: 20px;
                top: 23px;
            }

            .shell{
                width: 100px;
                position: relative;
                bottom: 7px;
                right: 3px
            }
        }
    }

    .sustentabilidade-inovacao{
        .logo-transparente{
                display: none;
            }

        h2{
            width: 100%;
            text-align: center;
            font-size: 42px;
            font-weight: 300;
            margin-top: 100px;

            b{
                font-size: 42px;
            }
        }

        h5{
            width: 100%;
            text-align: center;
            font-size: 24px;
            font-weight: 300;
            margin-top: 10px;
        }

        .div-imagem-topicos{
            width: 100%;
            display: flex;
            margin-top: 40px;
            flex-direction: column-reverse;

            .foto-sustentabilidade{
                width: 100%;
                height: 600px;
                margin-top: 70px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(${Faixada});
                border-radius: 0px 6px 6px 0px;
            }
        }

        .topicos{
            margin-left: 100px;
            width: 80%;
            margin: 0 auto;
        }

        .topico{
            display: flex;
            align-items: center;
            margin-bottom: 40px;

            h4{
                font-size: 70px;
                font-weight: 200;
                width: 80px;
                text-align: center;
            }

            .text-align{
                text-align:center;
            }

            h5{
                font-size: 22px;
                text-align: left;
                height: max-content;
                text-align: center;

            
                b{
                    font-size: 22px;
                }
            }
            
            .flex{
                align-items: center;
                flex-direction: column;
            }
        }

        .margin0{
            margin: 0px;
        }
    }

    .div-cases{
        margin-top: 57px;

        .h3-cases{
            width: 100%;
            display: flex;
            justify-content: center;
            font-size: 42px;
            font-weight: 300;

            b{
                font-size: 42px;
                font-weight: 300;
                margin-left: 10px;
            }
        }
    }

    .titulo-case{
        display: flex;
        width: 90%;
        align-items: center;
        margin: 30px auto 0px;
        position: relative;

        h3{
            position: absolute;
            top: 0px;
            font-size: 30px;
            font-weight: 300;

            b{
                font-size: 30px;
                font-size: 500;
            }
        }

        .titulo{
            width: 35%;
            margin-right: 40px;

            h4{
               font-size: 22px;
               font-weight: 300;

               b{
                font-size: 22px;
                font-weight: 500;
               }
            }

            h5{
                font-size: 22px;
                font-weight: 300;
                margin-top: 21px;
            }
        }

        .cases{
            width: 65%;
            display: flex;
            justify-content: center;
            /* max-height: 420px; */

            .foto-tapete, .foto-caminhao, .foto-futbol, .foto-parede-shell{
                width: 50%;
                aspect-ratio: 1 / 1;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(${Tapete});
                /* border-radius: 0px 6px 6px 0px; */
                margin-right: 8px;
                border-radius: 6px 0px 0px 6px;
            }

            .foto-caminhao{
                background-image: url(${Caminhoes});
            }

            .foto-futbol{
                background-image: url(${Futbol});
            }

            .foto-parede-shell{
                background-image: url(${ParedeShell});
            }

            figure{
                width: 100%;
            }

            .imagem1{
                width: 100%;
                div{
                    width: 100%;
                }

                svg{
                    width: 100%;
                    height: auto;
                }
            }

            .imagem2, .imagem3{
                width: 100%;
                height: 100%;
                aspect-ratio: 1 / 0.8;

                div{
                    width: 100%;
                    height: 54%;
                }

                svg{
                    width: 100%;
                    height: 59%;
                }
            }

            .imagem2{
                border-radius: 0px 6px 0px 0px;
            }

            .imagem3{
                border-radius: 0px 0px 6px 0px;
            }

            .cases-column{
                display: flex;
                flex-direction: column;
                gap: 8px;
                width: 30%;
            }

            .pepsi{
                aspect-ratio: 1 / 2;
            }
        }
    }

    .titulo-case-mobile{
        display: flex;
        flex-direction: column;
        width: 90%;
        margin: 50px auto 50px;

        .titulo{
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            h4{
                font-size: 22px;
                margin-left: 8px;

                b{
                    font-size: 22px;
                }
            }
        }
        h4{
            font-size: 18px;
            font-weight: 300;

               b{
                font-size: 18px;
                font-weight: 500;
               }
            }

            h5{
                font-size: 18px;
                font-weight: 300;
            }

        .cases{
            width: 100%;
            display: flex;
            margin-bottom: 10px;

            .foto-tapete, .foto-caminhao, .foto-futbol, .foto-parede-shell{
                width: 75%;
                aspect-ratio: 1 / 1;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(${Tapete});
                border-radius: 0px 6px 6px 0px;
                margin-right: 10px;
            }

            .foto-caminhao{
                background-image: url(${Caminhoes});
            }

            .foto-futbol{
                background-image: url(${Futbol});
            }

            .foto-parede-shell{
                background-image: url(${ParedeShell});
            }

            figure{
                width: 100%;
            }

            .imagem1{
                width: 100%;
                div{
                    width: 100%;
                }

                svg{
                    width: 100%;
                    height: auto;
                }
            }

            .imagem2, .imagem3{
                width: 100%;
                aspect-ratio: 1 / 1;

                div{
                    width: 100%;
                }

                svg{
                    width: 100%;
                    height: 50%;
                }
            }

            .cases-column{
                display: flex;
                flex-direction: column;
                gap: 20px;
                width: 50%;
            }

            .pepsi{
                aspect-ratio: 1 / 2;
            }
        }
    }

    .background-footer{
        width: 100%;
        height: 100vh !important;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        /* margin-top: 80px; */

        .background-container {
            position: relative;
            width: 100%;
            height: 100vh;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

            .background-video {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                z-index: -1;
        }

            .content {
                width: 90%;
                margin: 0 auto;
                z-index: 1;

                text-align: center;
        }

        h2{
            font-size: 48px;
            font-weight: 300;
            color: #ffffff;
            max-width: 1300px;
            text-align: center;
            margin: 30px 0px;
            margin: 30px auto;

            b{
                font-size: 48px;
                font-weight: 500;
                color: #ffffff;
            }
        }

        button{
            display: flex;
            align-items: center;
            border-radius: 50px;
            border: solid 1.2px #ffffff;
            background: none;
            padding: 8px 30px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 500;
            margin: 0 auto;

            div{
                width: 20px;
                height: 20px;
                margin-left: 4px;
            }
            svg{
                width: 20px;
                height: 20px;
            }
        }

        button:hover{
            background-color: #ffffff;
            color: #007046;
        }
    }

    footer{
        position: relative;

        h4{
            font-size: 42px;
            font-weight: 300;
            width: 90%;
            text-align: center;
            max-width: 1700px;
            margin: 140px auto 0px;

            b{
                font-size: 42px;
                font-weight: 500;
            }
        }

        .flex-center{
            display: flex;
            justify-content: center;
            flex-direction: column;
            padding-bottom: 30px;


            .logo-final{
                margin: 0 auto;
                width: 370px;
                height: 300px;
            }
        }

        .flex-column{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex-direction: column-reverse;

            .icones{
                svg{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }

            span{
                font-size: 20px;
            }
        }

        .final{
            width: 100%;
            display: flex;
            justify-content: center;
            background-color: #007046;
            color: #ffffff;
            font-size: 16px;
            font-weight: 400;
            padding: 6px 0px;
            position: absolute;
            bottom: -1px;
        }
    }

    .desktop{
        display: none;
    }

    @media(min-width: 450px){
        .h4-mobile{
            font-size: 30px;

            b{
                font-size: 30px;
            }
        }

        .div-marcas{
            .marcas{
                gap: 20px 10px;
                max-width: 440px;

                .ambev{
                    width: 113.177216px;
                    height: 30px;
                    position: relative;
                    right: 10px;
                    bottom: 0px;
                }

                .arcor{
                    width: 76.55325317382812px;
                    height: 46px;
                    position: relative;
                    left: 82px;
                }

                .kfc{
                    width: 76px;
                    height: 28px;
                    position: relative;
                    top: 1px;
                }

                .shell{
                    width: 76px;
                    height: 34px;
                    left: 79px;
                }

                .mars{
                    margin: 0;
                    position: relative;
                    top: 2px;
                    right: 5px;
                    display: flex;
                    width: 86.553253px;
                    height: 27px;
                }

                .red-bull{
                    margin: 0;
                    position: relative;
                    top: 0px;
                    left: 14px;
                    width: 103px;
                    height: 28px;
                }

                .linha-dois{
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    align-items: center;
                    gap: 20px 0px;


                    .burguer-king{
                        margin: 0;
                        position: relative;
                        left: 144px;
                        width: 42px;
                        top: 0px;
                    }

                    .oxxo{
                        width: 70px;
                        margin: 0px;
                        position: relative;
                        left: 34px;
                    }

                    .pepsico{
                        position: relative;
                        right: 10px;
                        width: 80px;
                        height: 18px;
                        top: 3px;
                    }
                }
            }

        }
        
        .h2-header-bottom{
            width: 92%;
        }

        .div-produtos-servicos{
            .cards{
                width: 90%;
                gap: 30px;
            }
        }
    }

    @media(min-width: 600px){
        .div-marcas .marcas {
            .ambev{
                width: 121.177216px;
                height: 31px;
                right: 62px;
            }

            .mars{
                width: 97.553253px;
                right: 27px;
            }

            .kfc{
                left: 7px;
            }

            .red-bull{
                left: 44px;
            }

            .shell{
                width: 89px;
                height: 42px;
                left: 48px;
            }

            .linha-dois{
                .oxxo{
                    width: 80px;
                    left: 40px;
                }

                .pepsico{
                    top: 0px;
                    right: -12px;
                    width: 141px;
                    height: auto;
                }

                .burguer-king{
                    left: 135px;
                    width: 52px;
                }

                .arcor{
                    width: 84px;
                    height: auto;
                    left: 103px;
                }
            }
        }
    }

    @media(min-width: 750px){
        .div-marcas{

            .mobile{
                display: none;
            }

            .desktop{
                display: flex;
            }

            .marcas{
                gap: 20px 40px;
                max-width: 1000px;

                .ambev{
                    right: 22px;
                }

                .arcor{
                    left: -7px;
                    height: auto;
                    bottom: 6px;
                }
                
                .shell{
                        width: 100px;
                        height: 50px;
                        left: 20px;
                    }

                .kfc{
                    position: relative;
                    top: 8px;
                }

                .linha-dois{
                    width: 100%;
                    max-width: 675px;
                    grid-template-columns: repeat(5, 1fr);
                    
                    .mars{
                        right: -22px;
                    }

                    .burguer-king{
                        width: 50px;
                        left: 57px;
                    }

                    .oxxo{
                        width: 75px;
                        left: 40px;
                    }

                    .red-bull{
                        width: 100px;
                        height: auto;
                        left: 30px;
                    }

                    .pepsico{
                        width: 120px;
                        height: 20px;
                        left: 32px;
                        bottom: 10px;
                    }
                }
            }
        }
    }

    @media(min-width: 1100px){

        .h3-mobile{
            display: none;
        }

        .faixa-verde{
            height: max-content;
            .body-desktop{
                position: relative;
                display: flex;
                width: 90%;
                max-width: 1690px;
                margin: 0 auto;
                padding: 60px 40px;
                
                h3{
                    display: block;
                    position: relative;
                    z-index: 2;
                }
            }
            .globo-cortado{
                position: absolute;
                top: 0px;
                right: 0px;
                height: 100%;
                width: max-content;
                display: block;

                div{
                    height: 100%;
                }

                svg{
                    height: 100%;
                }
            }
        }

        .div-impressoes{
            flex-direction: row;

            .impressoras{
                width: 40%;
                height: auto;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(${Impressoras});
                border-radius: 0px 6px 6px 0px;
            }

            .logo-transparente{
                display: flex;
                position: absolute;
                top: -200px;
                right: 0px;
            }
        }

        .div-impressoes {
            margin-top: 100px;
            .div-direita{
                display: flex;
                position: relative;
                flex-direction: column;
                width: calc(55% - 70px);
                margin-left: 70px;
                
                .cards{
                    align-items: flex-start;
                    flex-direction: row;
                
                    .card{
                        width: 30%;

                        img{
                            width: 100%;
                        }
                    }
                }

                h5{
                    font-size: 24px;
                    font-weight: 300;
                    margin: 0;
                    text-align: left;
                    width: 100%;

                    b{
                        font-size: 24px;
                    }
                }
            }

            .h4-desktop{
                display: block;
            }
        }

        .div-cases{
            margin-top: 127px;
        }

        .h4-mobile{
            display: none;
        }

        .div-produtos-servicos{
            h3{
                display: flex;
                justify-content: center;
                width: 100%;
                text-align: start;
            }

        .cards{
            width: 80%;
            display: flex;
            margin: 0 auto;
            justify-content: space-between;
            margin-bottom: 90px;
            

            .card{
                position: relative;
                width: 20%;
                max-width: 280px;
                aspect-ratio: 1 / 1;
                border: 2px solid #007046;
                border-radius: 20px;
                display: flex;
                text-align: center;
                align-items: center;
                padding: 10px;

                h5{
                    font-size: 19px;

                    b{
                        font-size: 19px;
                    }
                }
                }
            }
        }

        .div-marcas{
            .body{
                flex-direction: row;
            }

            .mobile{
                display: none;
            }

            .desktop{
                display: flex;
            }

            .marcas{
                max-width: 1000px;
                margin-top: 0px;
                width: 60%;
                gap: 20px 16px;

                display: flex;
                flex-direction: row;
                align-items: center;
                grid-template-columns: repeat(5, 1fr);
                flex-wrap: wrap;

                div{
                    width: 120px;
                    height: 100px;
                    display: flex;
                    align-items: center;

                    svg{
                        width: 100%;
                    }
                }

                .linha-dois{
                    gap: 20px 20px;
                    width: 100%;
                    max-width: none;
                    display: flex;
                    flex-wrap: wrap;

                    justify-content: center;
                }

                .ambev{
                    width: 123px;
                    height: auto;
                }

                .arcor{
                    bottom: 0px;
                }

                .kfc{
                    top: 2px;
                }

                .linha-dois{
                    .mars{
                        right: 18px;
                    }

                    .burguer-king{
                        width: 50px;
                        left: 25px;
                    }

                    .red-bull{
                        left: 50px;
                    }

                    .oxxo{
                        left: 46px;
                    }

                    .pepsico{
                        left: 55px;
                    }
                }
            }

            h2{
                text-align: start;
                font-size: 42px;
                width: 500px;

                b{
                font-size: 42px;
                }
            }
        }

        .sustentabilidade-inovacao{
            position: relative;

            .logo-transparente{
                display: flex;
                position: absolute;
                top: -300px;
                right: 0px;
        }

            .div-imagem-topicos{
                margin-top: 84px;
                flex-direction: row;

                .foto-sustentabilidade{
                    width: 50%;
                    height: auto;
                    margin-top: 0px;
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url(${Faixada});
                    border-radius: 0px 6px 6px 0px;
                }
                
                .topicos{
                    width: 40%;
                    margin-left: 60px;
                }

                .topico{
                    margin: 60px 0px;

                    h4{
                        text-align: start;
                    }

                    .topico1{
                        padding-left: 12px;
                    }

                    h5{
                        text-align: left;
                        max-width: 700px;
                    }

                    .flex{
                        flex-direction: row;
                    }
                }
            }
        }

        .desktop{
            display: flex;
            flex-direction: column;
        }

        .mobile{
            display: none;
        }

        .background-footer{
                margin-top: 200px;
            
                h2{
                    font-size: 90px;
                b{
                    font-size: 90px;
                }
            }
        }

        footer{
            .flex-center{
                display: flex;
                flex-direction: row;
                
                .logo-final{
                    margin: 0px 50px 0px 0px;
                }
            }

            .flex-column{
                margin-top: 70px;
                justify-content: center;
                align-items: start;
            }

            h4{
                margin-top: 80px;
                font-size: 32px;

                b{
                    font-size: 32px;
                }
            }
        }

        .h2-header-bottom{
            padding: 80px 40px;
        }
    }

    @media(min-width: 1350px){
        .div-marcas{
            .marcas{
                gap: 20px 60px;
                .linha-dois{
                    gap: 20px 60px;
                
                    .mars{
                        margin-top: 7px;
                        margin: 0px;
                    }

                    .burguer-king{
                        width: 58px;
                        margin: 0px;
                    }

                    .oxxo{
                        width: 80px;
                        margin: 0px;
                    }

                    .red-bull{
                        width: 120px;
                        height: 35px;
                        margin-right: 0px;
                    }

                    .pepsico{
                        margin-top: 0px;
                    }
                
                }
            }
        }
    }
`